import Th from "@/components/Table/Th";
import { table_head } from "../maintainers.module.scss";
import { table_titles } from "./products.constants";

const shouldShowTitle = (title, { isMaintainerView, filter }) => {
	const { is_generic, customer_id } = filter;

	if (isMaintainerView) {
		const hiddenForMaintainer = ["Precio Unitario ($/Kg, L)"];
		return !hiddenForMaintainer.includes(title.name);
	}

	if (!isMaintainerView) {
		const allowedIfTrue = ["", "Nombre", "Ingrediente Activo", "Aptitud", "U.M.", "Acción", "Precio Unitario ($/Kg, L)"];
		const allowedIfFalse = [
			"",
			"Nombre",
			"Ingrediente Activo",
			"Aptitud",
			"Bodega",
			"Código",
			"Stock",
			"U.M.",
			"Conteo",
			"Acción",
			"Precio Unitario ($/Kg, L)",
		];
		return is_generic ? allowedIfFalse.includes(title.name) : allowedIfTrue.includes(title.name);
	}

	if (!is_generic && !customer_id) {
		const hiddenForAnonymous = ["Cliente", "Bodega", "Código", "Stock", "Conteo"];
		return !hiddenForAnonymous.includes(title.name);
	}

	return true;
};

const ProductsTableHead = ({ order, setOrder, orderType, setOrderType, filter, isMaintainerView }) => {
	const filteredTitles = table_titles.filter((title) => shouldShowTitle(title, { isMaintainerView, filter }));

	return (
		<thead className={table_head}>
			<tr>
				{filteredTitles.map((title, i) => (
					<Th
						key={i}
						item_name={title.name}
						item_size={title.size}
						item_order={title.order}
						order={order}
						setOrder={setOrder}
						orderType={orderType}
						setOrderType={setOrderType}
						item_class={title.class}
						only_admin={title.only_admin}
						border_color="0.5px solid #7fb02f"
					/>
				))}
			</tr>
		</thead>
	);
};

export default ProductsTableHead;
